import React from 'react'

import { Typography } from "@mui/material"


export default function nameColumn() {

	return {
		name: 'name',
		label: 'Name',
		options: {
			filterType: 'textField',
			headerAlign: 'left',
			customBodyRowRenderLite: value => <Typography>{value}</Typography>,
		}
	}
}